import { connect } from 'react-redux';
import ArcadeRoom from './Room';
import {
    getRoom,
    hasCabinets,
    getCabinetOptions
} from '../../selectors';
import {
    setReorderedCabinets,
    createArcadeRoom,
    updateArcadeRoom,
    setRoomValue,
    addCabinetToRoom,
    removeRoomCabinet
} from '../../actions';
import { getArcadeCabinets } from 'arcade/sections/cabinets/actions';

const mapStateToProps = state => ({
    room: getRoom(state),
    hasCabinets: hasCabinets(state),
    cabinetOptions: getCabinetOptions(state),
});

const mapDispatchToProps = {
    setReorderedCabinets,
    createArcadeRoom,
    updateArcadeRoom,
    setRoomValue,
    getArcadeCabinets,
    addCabinetToRoom,
    removeRoomCabinet
};

export default connect(mapStateToProps, mapDispatchToProps)(ArcadeRoom);
